<template>
  <div class="page">
    <el-container>
      <el-aside class="el-aside" :style="{width: fold ? 64 + 'px' : 200 + 'px'}">
        <nav-left :fold="fold"></nav-left>
      </el-aside>
      <el-container>
        <el-header>
          <headers @handleFold="handleFold"></headers>
        </el-header>
        <el-main style="overflow:auto;background:rgb(240,242,245)">
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import NavLeft from "@/components/navLeft"
import Headers from "@/components/header"
// import navMenu from "@/components/navMenu";
// import Breadcrumb from "@/components/Breadcrumb";

export default {
  name: 'index',
  components:{
    NavLeft,
    Headers,
    // navMenu
  },
  data () {
    return {
      fold: false,
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    /**
     * 折叠
     */
    handleFold() {
      this.fold = !this.fold
    },
  }
}
</script>

<style scoped>
.el-header{
  background-color: #fff;
  color: #333;
  text-align: center;
  line-height: 60px;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
}

.el-aside {
  background-color: #001529;
  color: #333;
  text-align: center;
  line-height: 200px;
  height: 100vh;
  text-align:left;
  transition: all .3s;
}

.el-main {
  background-color: #fff;
  color: #333;
  height: calc(100vh - 100px);
}
</style>



// WEBPACK FOOTER //
// src/layout.vue